import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faGraduationCap,
  faFolder,
} from "@fortawesome/free-solid-svg-icons";
import ProjectCard from "../components/cards/ProjectCard";
import Experience from "../components/cards/Experience";
import { education, experiences, projects } from "../constants/profile";
import Education from "../components/cards/Education";

const ProfileSection: React.FC = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsImageLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Loader */}
      {!isImageLoaded ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#070508]">
          <div className="animate-pulse">
            <div className="w-24 h-24 border-4 border-t-[#0f99b8] border-r-[#016e86] border-b-transparent border-l-transparent rounded-full animate-spin"></div>
            <p className="mt-4 text-[#0f99b8] text-center">Loading...</p>
          </div>
        </div>
      ) : (
        <div className="w-full mx-auto mb-10 px-4 py-12 lg:px-28 bg-gradient-to-b from-[#070508] via-[#080609] to-[#09090b] ... text-gray-300 font-poppins">
          {/* Experience Section */}
          <section className="mb-12 mt-20 relative">
            <div className="flex items-center mb-6">
              <FontAwesomeIcon
                icon={faBriefcase}
                className="mr-3 text-blue-400"
                size="2x"
              />
              <h2 className="text-2xl font-semibold text-gray-100">
                My Experience
              </h2>
            </div>
            <div className="space-y-6">
              {experiences.map((exp, index) => (
                <Experience experience={exp} key={index} />
              ))}
            </div>
          </section>

          {/* Projects Section */}
          <section className="mb-12 relative">
            <div className="flex items-center mb-2">
              <FontAwesomeIcon
                icon={faFolder}
                className="mr-3 text-green-400"
                size="2x"
              />
              <h2 className="text-3xl font-semibold text-gray-100">
                Notable Projects
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {projects.map((project, index) => (
                <ProjectCard project={project} key={index} />
              ))}
            </div>
          </section>

          {/* Education Section */}
          <section className="md:mt-16">
            <div className="flex items-center mb-6">
              <FontAwesomeIcon
                icon={faGraduationCap}
                className="mr-3 text-purple-400"
                size="2x"
              />
              <h2 className="text-3xl font-semibold text-gray-100">
                Education
              </h2>
            </div>
            <div className="space-y-6">
              {education.map((edu, index) => (
                <Education education={edu} key={index} />
              ))}
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default ProfileSection;
